var _excluded = ["xs", "sm", "md", "lg", "xl", "xxl", "order", "orderSm", "orderMd", "orderLg", "orderXl", "orderXxl", "children", "className", "as"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import grid from "@xo-union/tk-css-grid/lib/styles.css";
var getGridSizeClasses = function getGridSizeClasses(breakpoints) {
  var _context;
  return _reduceInstanceProperty(_context = _Object$keys(breakpoints)).call(_context, function (classes, key) {
    if (!breakpoints[key]) {
      return classes;
    }
    var sizeSuffix = breakpoints[key] === true ? '' : "-".concat(breakpoints[key]);
    var breakpointInfix = key === 'xs' ? '' : "-".concat(key);
    return cx(classes, grid["col".concat(breakpointInfix).concat(sizeSuffix)]);
  }, '');
};
var getGridOrderClass = function getGridOrderClass(orderBreakpoints) {
  var _context2;
  return _reduceInstanceProperty(_context2 = _Object$keys(orderBreakpoints)).call(_context2, function (classes, key) {
    if (!orderBreakpoints[key]) {
      return classes;
    }
    var _key$match = key.match(/order(..)?$/),
      _key$match2 = _slicedToArray(_key$match, 2),
      breakpoint = _key$match2[1];
    var breakpointInfix = breakpoint ? "-".concat(breakpoint.toLowerCase()) : '';
    var valueSuffix = "-".concat(orderBreakpoints[key]);
    return cx(classes, grid["order".concat(breakpointInfix).concat(valueSuffix)]);
  }, '');
};
var Column = function Column(_ref) {
  var xs = _ref.xs,
    sm = _ref.sm,
    md = _ref.md,
    lg = _ref.lg,
    xl = _ref.xl,
    xxl = _ref.xxl,
    order = _ref.order,
    orderSm = _ref.orderSm,
    orderMd = _ref.orderMd,
    orderLg = _ref.orderLg,
    orderXl = _ref.orderXl,
    orderXxl = _ref.orderXxl,
    children = _ref.children,
    className = _ref.className,
    ComponentToRender = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = [getGridOrderClass({
    order: order,
    orderSm: orderSm,
    orderMd: orderMd,
    orderLg: orderLg,
    orderXl: orderXl,
    orderXxl: orderXxl
  }), getGridSizeClasses({
    xs: xs,
    sm: sm,
    md: md,
    lg: lg,
    xl: xl,
    xxl: xxl
  }), className];
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    className: cx(classes)
  }, props), children);
};
var allowedColumnValues = process.env.NODE_ENV !== "production" ? ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] : {};
var columnNumberPropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOf(allowedColumnValues) : {};
var allowedColumnSizeProps = process.env.NODE_ENV !== "production" ? _concatInstanceProperty(allowedColumnValues).call(allowedColumnValues, [true, 'auto']) : {};
var columnSizePropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOf(allowedColumnSizeProps) : {};
process.env.NODE_ENV !== "production" ? Column.propTypes = {
  /**
   * Component to render
   */
  as: PropTypes.elementType,
  xs: columnSizePropType,
  sm: columnSizePropType,
  md: columnSizePropType,
  lg: columnSizePropType,
  xl: columnSizePropType,
  xxl: columnSizePropType,
  order: columnNumberPropType,
  orderSm: columnNumberPropType,
  orderMd: columnNumberPropType,
  orderLg: columnNumberPropType,
  orderXl: columnNumberPropType,
  orderXxl: columnNumberPropType,
  children: PropTypes.node,
  className: PropTypes.string
} : void 0;
Column.defaultProps = {
  className: '',
  as: 'div'
};
export default Column;